import React from 'react';

const speakers = [
  { initials: 'PB', name: 'PASTOR BEVERLY', title: 'Zone B — Grace City', bio: 'Anointed minister of the Word, Zone B Pastor, Grace City.' },
  { initials: '+', name: 'MORE SPEAKERS', title: 'Announcement Coming Soon', bio: 'Additional ministers will be announced. Stay connected.' },
];

export default function Speakers() {
  return (
    <section id="speakers" style={{ padding: '120px 64px' }}>
      <style>{`
        @media(max-width:768px){ #speakers{padding:80px 24px!important;} .speakers-grid{grid-template-columns:repeat(2,1fr)!important;} }
        @media(max-width:480px){ .speakers-grid{grid-template-columns:1fr!important;} }
        .speaker-img-wrap { overflow:hidden; }
        .speaker-img-wrap:hover .speaker-img-inner { transform: scale(1.04); }
        .speaker-img-inner { transition: transform 0.6s ease; }
      `}</style>

      <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>Ministers</p>
      <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 24 }}>
        VOICES SENT<br />TO YOUR CITY
      </h2>
      <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 24px' }} />
      <p className="reveal" style={{ fontFamily: 'var(--font-serif)', fontSize: 18, lineHeight: 1.75, color: 'rgba(245,240,232,0.55)', maxWidth: 520, marginBottom: 0 }}>
        Anointed, Word-based ministers carrying a message that will transform your life and your city.
      </p>

      <div className="speakers-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 280px))', gap: 32, marginTop: 64 }}>
        {speakers.map((s, i) => (
          <div key={s.name} className={`reveal reveal-d${i + 1}`} style={{ position: 'relative' }}>
            <div className="speaker-img-wrap" style={{ marginBottom: 20, background: 'var(--ash-mid)' }}>
              <div className="speaker-img-inner" style={{ aspectRatio: '3/4', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', background: 'linear-gradient(135deg, var(--ash-mid) 0%, rgba(200,68,10,0.1) 100%)' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 72, color: 'rgba(200,68,10,0.25)' }}>{s.initials}</div>
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg,transparent 50%,rgba(8,8,8,0.8) 100%)' }} />
              </div>
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, letterSpacing: '0.05em', color: 'var(--white)', marginBottom: 4 }}>{s.name}</div>
            <div style={{ fontSize: 10, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--ember)' }}>{s.title}</div>
            <p style={{ fontSize: 13, color: 'rgba(245,240,232,0.4)', lineHeight: 1.6, marginTop: 10 }}>{s.bio}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
